<template>
	<div>
		<router-view />
	</div>
</template>

<script>
	export default {
		data() {
			return {
	
			}
		},
		components: {
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/jm/home.vue